import React from "react";
import {
  TextInput,
  SimpleForm,
  Edit,
  required,
  SelectInput,
  EditProps,
} from "react-admin";
import TitleBreadcrumb from "components/TitleBreadcrumb";
import CustomLevelInput from "components/CustomLevelInput";
import { GetParam } from "utils/tools";
import CustomFormLabel from "components/CustomFormLabel";
import SanitizedGrid from "components/SanitizedGrid";
import { Grid, Typography } from "@material-ui/core";
import { statusList } from "pages/levels/util";
import CustomEditToolbar from "components/CustomEditToolbar";

const LevelGroupsEdit = (props: EditProps) => {
  const param = GetParam();
  const { id } = props;

  const breadcrumb = [
    { title: "Schools", link: `/schools` },
    { title: "Levels", link: `/schools/${param.get("schoolId")}/show/1` },
    {
      title: "Class",
      link: `/levels/${param.get("levelId")}/show`,
      params: `?schoolId=${param.get("schoolId")}`,
    },
    { title: id, link: `` },
  ];

  return (
    <>
      <TitleBreadcrumb paths={breadcrumb} />
      <CustomFormLabel property={props} isNoActions />
      <Edit {...props} title="Class" undoable={false}>
        <SimpleForm
          toolbar={
            <CustomEditToolbar
              redirectLink={`/levels/${param.get(
                "levelId"
              )}/show?schoolId=${param.get("schoolId")}`}
            />
          }
        >
          <SanitizedGrid container spacing={2}>
            <Grid item xs={12}>
              <Typography variant="h6">Level</Typography>
            </Grid>
            <Grid item xs={4}>
              <CustomLevelInput />
            </Grid>
            <Grid item xs={8}></Grid>

            <Grid item xs={12}>
              <Typography variant="h6">Details</Typography>
            </Grid>
            <Grid item xs={4}>
              <TextInput source="name" validate={required()} />
            </Grid>
            <Grid item xs={4}>
              <SelectInput
                source="status"
                choices={statusList}
                validate={required()}
              />
            </Grid>
          </SanitizedGrid>
        </SimpleForm>
      </Edit>
    </>
  );
};

export default LevelGroupsEdit;
